<div class="container-fluid pt-2" style="height: fit-content; min-height: calc(100vh - 103px)">
  <div class="row align-items-stretch" style="min-height: 87vh !important;">

    <!-- Columna izquierda: estado del reloj -->
    <div class="col-xl-8 col-lg-7 col-md-12 d-flex flex-column">
      <div class="card" style="min-height: 100%;">
        <div class="card-header py-2 d-flex align-items-center justify-content-between">
          <h6 class="card-title mb-0">{{ 'status' | translate }}</h6>
          <div class="d-flex align-items-center gap-2">
            <span
              class="d-inline-flex align-items-center gap-2 px-2 py-1 rounded-pill border border-warning bg-warning bg-opacity-10"
              *ngIf="warning"
            >
              <i
                class="fas fa-exclamation-triangle text-warning"
                [title]="clockDriftWarningTitle"
                [attr.aria-label]="clockDriftWarningTitle"
                style="cursor: help;"
              ></i>
              <i
                class="fas fa-rotate-right text-secondary"
                [class.fa-spin]="loadingClockSync"
                [class.opacity-50]="loadingClockSync || loading"
                role="button"
                tabindex="0"
                [title]="loadingClockSync ? ('dlClockSyncing' | translate) : ('dlClockSync' | translate)"
                [attr.aria-label]="loadingClockSync ? ('dlClockSyncing' | translate) : ('dlClockSync' | translate)"
                [style.cursor]="loadingClockSync || loading ? 'wait' : 'pointer'"
                (click)="!loadingClockSync && !loading && syncClock()"
              ></i>
            </span>
            <i
              *ngIf="!warning"
              class="fas fa-rotate-right text-secondary"
              [class.fa-spin]="loadingClockSync"
              [class.opacity-50]="loadingClockSync || loading"
              role="button"
              tabindex="0"
              [title]="loadingClockSync ? ('dlClockSyncing' | translate) : ('dlClockSync' | translate)"
              [attr.aria-label]="loadingClockSync ? ('dlClockSyncing' | translate) : ('dlClockSync' | translate)"
              [style.cursor]="loadingClockSync || loading ? 'wait' : 'pointer'"
              (click)="!loadingClockSync && !loading && syncClock()"
            ></i>
          </div>
        </div>

        <div class="card-body d-flex align-items-center justify-content-center" *ngIf="loading">
          <div class="spinner-border" role="status" style="width: 3rem; height: 3rem; border-width: 0.35em;">
            <span class="visually-hidden">{{ 'loading' | translate }}</span>
          </div>
        </div>

        <div class="card-body pt-4" *ngIf="!loading">
          <div #overlayContainer class="position-relative">
            <canvas #nowLinesOverlay class="position-absolute top-0 start-0"
              style="width: 100%; height: 100%; z-index: 2; pointer-events: none;"></canvas>
            <canvas #pulseZoomOverlay class="position-absolute top-0 start-0"
              style="width: 100%; height: 100%; z-index: 3; pointer-events: none;"></canvas>

            <div class="d-flex flex-column gap-2 py-1" style="position: relative; z-index: 1;">
              <div class="chart-container" style="position: relative; width: 100%;"
                [style.height.px]="outputCount > 1 ? 240 : 480"
                (mousemove)="onChartMouseMove($event, 1)"
                (mouseleave)="onChartMouseLeave(1)">
                <canvas #programTodayOut1></canvas>
              </div>
              <div class="chart-container" *ngIf="outputCount > 1" style="position: relative; height: 240px; width: 100%;"
                (mousemove)="onChartMouseMove($event, 2)"
                (mouseleave)="onChartMouseLeave(2)">
                <canvas #programTodayOut2></canvas>
              </div>
            </div>
          </div>

          <div class="mt-4 py-2">
            <div class="d-flex flex-column align-items-center gap-2">
              <div class="d-flex flex-wrap justify-content-center align-items-center gap-3">
                <div class="d-inline-flex align-items-center gap-2">
                  <i class="fas fa-minus fa-lg text-warning-2"></i>
                  <span class="small text-uppercase fw-semibold text-secondary">{{ 'on' | translate }}</span>
                </div>
                <div class="d-inline-flex align-items-center gap-2">
                  <i class="fas fa-minus fa-lg text-secondary"></i>
                  <span class="small text-uppercase fw-semibold text-secondary">{{ 'off' | translate }}</span>
                </div>
                <div class="d-inline-flex align-items-center gap-2">
                  <span class="badge rounded-circle bg-primary d-inline-flex align-items-center justify-content-center"
                    style="width: 22px; height: 22px;">
                    <img src="assets/img/orbis/cycle-icon.svg" alt="" width="14" height="14">
                  </span>
                  <span class="small text-muted">{{ 'dlCycleSchedule' | translate }}</span>
                </div>
                <div class="d-inline-flex align-items-center gap-2">
                  <span class="badge rounded-circle bg-primary d-inline-flex align-items-center justify-content-center"
                    style="width: 22px; height: 22px;">
                    <img src="assets/img/orbis/pulse-icon.svg" alt="" width="14" height="9">
                  </span>
                  <span class="small text-muted">{{ 'dlPulseSchedule' | translate }}</span>
                </div>
                <div class="d-inline-flex align-items-center small" *ngIf="clockTime?.timeStr">
                  <i class="fas fa-clock text-primary me-1"></i>
                  <span class="fw-semibold text-secondary">{{ 'dlClockLabel' | translate }}</span>
                  <span class="text-muted fw-bold ms-1">{{ clockTime.timeStr }}</span>
                </div>
                <div class="d-inline-flex align-items-center small" *ngIf="todayPeriod?.inPeriod">
                  <i class="fas fa-calendar-day text-info me-1"></i>
                  <span class="fw-semibold text-secondary">{{ 'dlCurrentPeriod' | translate }}</span>
                  <span class="text-muted fw-bold ms-1">{{ todayPeriod.periodIndex }}</span>
                </div>
                <div class="d-inline-flex align-items-center small" *ngIf="todayPeriod && !todayPeriod.inPeriod">
                  <i class="fas fa-calendar-day text-muted me-1"></i>
                  <span class="fw-semibold text-secondary">{{ 'dlCurrentPeriod' | translate }}</span>
                  <span class="text-muted fw-bold ms-1">{{ 'dlNotHoliday' | translate }}</span>
                </div>
              </div>

              <div class="d-inline-flex align-items-center gap-2"
                *ngIf="pulseRegionsOut1.length || pulseRegionsOut2.length || cycleRegionsOut1.length || cycleRegionsOut2.length">
                <i class="fas fa-search-plus text-primary"></i>
                <span class="small text-muted">{{ 'dlScheduleHoverHint' | translate }}</span>
              </div>
            </div>

            <div class="d-flex flex-column align-items-center gap-2 mt-4 py-3 holiday-periods" *ngIf="holidayInfo?.periods?.length">
              <div class="small fw-semibold text-secondary">{{ 'ancHolidayPeriodsConfigured' | translate }}</div>

              <div class="d-flex flex-wrap justify-content-center align-items-stretch gap-2 w-100 holiday-periods-list">
                <div class="d-flex align-items-center gap-2 rounded-3 border px-2 py-1 holiday-period-item"
                  *ngFor="let period of holidayInfo?.periods; let i = index"
                  [ngClass]="period?.enable == 1
                    ? (i === 0
                      ? 'border-2 border-primary bg-primary bg-opacity-10'
                      : i === 1
                        ? 'border-2 border-success bg-success bg-opacity-10'
                        : i === 2
                          ? 'border-2 border-danger bg-danger bg-opacity-10'
                          : 'border-2 border-secondary bg-secondary bg-opacity-10')
                    : 'opacity-50 border-secondary border-opacity-25 bg-light bg-opacity-50'">
                  <div class="d-flex align-items-center justify-content-center rounded-2 text-white flex-shrink-0"
                    [ngClass]="i === 0 ? 'bg-primary' : i === 1 ? 'bg-success' : i === 2 ? 'bg-danger' : 'bg-secondary'"
                    style="width: 26px; height: 26px;">
                    <span class="fw-semibold small">{{ period.period }}</span>
                  </div>

                  <div class="small text-muted fw-semibold holiday-period-text">
                    {{ period.startDayStr }} <i class="fa-solid fa-arrows-left-right"></i> {{ period.endDayStr }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Columna derecha -->
    <div class="col-xl-4 col-lg-5 col-md-12 d-flex gap-3 flex-column h-100">

      <div class="card h-100">
        <div class="card-header py-2">
          <h6 class="card-title mb-0">{{ 'deviceInfo' | translate }}</h6>
        </div>
        <div class="card-body py-2 d-flex flex-column gap-3">
          <div>
            <i class="fas fa-wifi fs-5 me-1" [class.text-success]="deviceInfo?.alive" [class.text-danger]="!deviceInfo?.alive"></i>
            <strong class="small">{{ deviceInfo?.alive ? ('connected' | translate) : ('disconnected' | translate) }}</strong>
          </div>
          <div *ngIf="modelDLData?.description">
            <i class="fas fa-microchip text-secondary me-1"></i>
            <strong class="small">{{ 'modelo' | translate }}:</strong>
            <small class="text-muted ms-1">{{ modelDLData.description }}</small>
          </div>
          <div>
            <i class="fas fa-history text-info me-1"></i>
            <strong class="small">{{ 'lastConnection' | translate }}:</strong>
            <small class="text-muted ms-1">{{ lastConnection | date:'medium' }}</small>
          </div>
        </div>
      </div>

      <div class="card h-100">
        <div class="card-header py-2">
          <h6 class="card-title mb-0">{{ 'counters' | translate }}</h6>
        </div>
        <div class="card-body py-2">
          <div class="d-flex justify-content-center align-items-center gap-4">
            <div class="text-center" *ngIf="outputCount > 1">
              <div class="data-item">
                <div class="data-icon bg-primary bg-opacity-10 mx-auto mb-2">
                  <i class="fas fa-clock text-primary"></i>
                </div>
                <div class="data-content text-center">
                  <div class="data-value">{{ totalCounterHours }} h</div>
                  <small class="data-label">{{ 'total' | translate }}</small>
                </div>
              </div>
            </div>
            <div class="text-center">
              <div class="data-item">
                <div class="data-icon bg-info bg-opacity-10 mx-auto mb-2" style="cursor: pointer;" (click)="resetCounter(1)">
                  <i class="fas fa-lightbulb text-info"></i>
                </div>
                <div class="data-content text-center">
                  <div class="data-value">{{ channelInfo?.stat?.c1counter || 0 }} h</div>
                  <small class="data-label">{{ 'output1' | translate }}</small>
                </div>
              </div>
            </div>
            <div class="text-center" *ngIf="outputCount > 1">
              <div class="data-item">
                <div class="data-icon bg-success bg-opacity-10 mx-auto mb-2" style="cursor: pointer;" (click)="resetCounter(2)">
                  <i class="fas fa-lightbulb text-success"></i>
                </div>
                <div class="data-content text-center">
                  <div class="data-value">{{ channelInfo?.stat?.c2counter || 0 }} h</div>
                  <small class="data-label">{{ 'output2Hours' | translate }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estado de las salidas -->
      <div class="row mb-2">
        <div class="col-12">
          <div class="card h-100">
            <div class="card-header py-2">
              <h6 class="card-title mb-0">
                {{ 'outputsState' | translate }}
              </h6>
            </div>
            <div class="card-body py-2 d-flex align-items-center justify-content-center gap-4">
              <!-- Salida 1 -->
              <div class="text-center">
                <div class="mb-2">
                  <div class="spinner-border text-primary" role="status" *ngIf="loadState.c1" style="height: 18px; width: 18px;">
                    <span class="visually-hidden">{{ 'loading' | translate }}</span>
                  </div>
                  <i class="fas fa-lightbulb fs-4 text-warning-2"
                     [class.text-muted]="channelInfo?.stat?.c1stat != 2 && channelInfo?.stat?.c1stat != 3" *ngIf="!loadState.c1"></i>
                </div>
                <div class="mb-1">
                  <h6 class="mb-0 text-primary fw-bold small d-inline-flex align-items-center gap-2">
                    {{ 'output1' | translate }}
                    <i class="fa-solid fa-lock text-warning" *ngIf="dlDeviceInfo?.permanent == 1 || dlDeviceInfo?.permanent == 3"></i>
                    <i class="fa-solid fa-unlock text-gray" *ngIf="dlDeviceInfo?.permanent == 0 || dlDeviceInfo?.permanent == 2"></i>
                  </h6>
                </div>
                <div (click)="changeOutput(1)"
                  [ngClass]="channelInfo?.stat?.c1stat == 2 || channelInfo?.stat?.c1stat == 3 ?
                    'd-flex align-items-center justify-content-center fw-bold rounded-2 border border-2' :
                    'border border-secondary border-2 bg-light text-muted rounded-2 d-flex align-items-center justify-content-center fw-bold'"
                  [ngStyle]="channelInfo?.stat?.c1stat == 2 || channelInfo?.stat?.c1stat == 3 ?
                    {'border-color': '#e3e330', 'background-color': 'rgba(227, 227, 48, 0.1)', 'color': '#e3e330'} :
                    {}"
                  style="min-width: 80px; height: 32px; font-size: 0.9rem; cursor: pointer;">
                  {{channelInfo?.stat?.c1stat == 2 || channelInfo?.stat?.c1stat == 3 ? ('on' | translate) : ('off' | translate)}}
                  <i class="fa-solid fa-hand-pointer ms-1 text-dark" *ngIf="channelInfo?.stat?.c1stat == 3 || channelInfo?.stat?.c1stat == 1"></i>
                </div>
              </div>

              <!-- Salida 2 -->
              <div class="text-center" *ngIf="outputCount > 1">
                <div class="mb-2">
                  <div class="spinner-border text-primary" role="status" *ngIf="loadState.c2" style="height: 18px; width: 18px;">
                    <span class="visually-hidden">{{ 'loading' | translate }}</span>
                  </div>
                  <i class="fas fa-lightbulb fs-4 text-warning-2"
                    [class.text-muted]="channelInfo?.stat?.c2stat != 2 && channelInfo?.stat?.c2stat != 3" *ngIf="!loadState.c2"></i>
                </div>
                <div class="mb-1">
                  <h6 class="mb-0 text-primary fw-bold small d-inline-flex align-items-center gap-2">
                    {{ 'output2Hours' | translate }}
                    <i class="fa-solid fa-lock text-warning" *ngIf="dlDeviceInfo?.permanent == 2 || dlDeviceInfo?.permanent == 3"></i>
                    <i class="fa-solid fa-unlock" *ngIf="dlDeviceInfo?.permanent == 0 || dlDeviceInfo?.permanent == 1"></i>
                  </h6>
                </div>
                <div (click)="changeOutput(2)"
                  [ngClass]="channelInfo?.stat?.c2stat == 2 || channelInfo?.stat?.c2stat == 3 ?
                    'd-flex align-items-center justify-content-center fw-bold rounded-2 border border-2' :
                    'border border-secondary border-2 bg-light text-muted rounded-2 d-flex align-items-center justify-content-center fw-bold'"
                  [ngStyle]="channelInfo?.stat?.c2stat == 2 || channelInfo?.stat?.c2stat == 3 ?
                    {'border-color': '#e3e330', 'background-color': 'rgba(227, 227, 48, 0.1)', 'color': '#e3e330'} :
                    {}"
                  style="min-width: 80px; height: 32px; font-size: 0.9rem; cursor: pointer;">
                  {{channelInfo?.stat?.c2stat == 2 || channelInfo?.stat?.c2stat == 3 ? ('on' | translate) : ('off' | translate)}}
                  <i class="fa-solid fa-hand-pointer ms-1 text-dark"
                    *ngIf="channelInfo?.stat?.c2stat == 3 || channelInfo?.stat?.c2stat == 1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cambio de estación -->
      <div class="row mb-2">
        <div class="col-12">
          <div class="card h-100">
            <div class="card-header py-2">
              <div class="d-flex align-items-center justify-content-between gap-2">
                <h6 class="card-title mb-0">
                  {{ 'seasonChange' | translate }}
                </h6>
                <span
                  class="badge"
                  [ngClass]="seasonsInfo?.enable ? 'bg-success' : 'bg-secondary'"
                >
                  {{seasonsInfo?.enable ? ('active' | translate) : ('inactive' | translate)}}
                </span>
              </div>
            </div>
            <div class="card-body py-2">
              <div class="d-flex flex-column gap-2 pb-2" *ngIf="seasonsInfo?.enable">
                <div class="d-flex align-items-center justify-content-between gap-3 pt-3">
                  <div class="d-inline-flex align-items-center gap-2">
                    <i class="fa-solid fa-sun text-warning"></i>
                    <span class="small fw-semibold text-secondary">{{ 'dlSeasonSummerChange' | translate }}</span>
                  </div>
                  <span class="small text-muted fw-semibold">{{seasonsInfo?.summer?.startDateTimeStr}}</span>
                </div>

                <div class="d-flex align-items-center justify-content-between gap-3 pb-3">
                  <div class="d-inline-flex align-items-center gap-2">
                    <i class="fa-solid fa-snowflake text-primary"></i>
                    <span class="small fw-semibold text-secondary">{{ 'dlSeasonWinterChange' | translate }}</span>
                  </div>
                  <span class="small text-muted fw-semibold">{{seasonsInfo?.winter?.startDateTimeStr}}</span>
                </div>
              </div>
              <div *ngIf="!seasonsInfo?.enable" class="text-center text-muted py-3">
                <i class="fas fa-calendar-times fa-2x mb-"></i>
                <div class="small">{{ 'noSeasonChangeScheduled' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
